import * as React from 'react';

import {Button} from 'shells/button/button';
import {Stack} from 'shells/layout/stack/stack';

import {appHistory} from '../../../../history';

import {ConnectionNextSteps} from '../../connection-next-steps/connection-next-steps';

import {CalendarModalPage} from './calendar-modal-page';

type Props = {
    onClose: () => void;
};

export function CalendarDone(props: Props) {
    React.useEffect(() => {
        window.dispatchEvent(new Event('onboarding-step-completed-email-calendar-sync'));
    }, []);

    return (
        <CalendarModalPage
            header='Great job! Your calendar is connected!'
            subheader='You can now send emails from inside of Nutshell and sync replies from your contacts automatically.'
            navButtons={
                <Stack spacing={12} justifyContent='end' isHorizontal={true} isFullWidth={true}>
                    <Button
                        variant='text'
                        size='big'
                        onClick={() => appHistory.push('/my-account/calendar')}
                    >
                        Review your settings
                    </Button>
                    <Button variant='primary' size='big' onClick={props.onClose}>
                        Done
                    </Button>
                </Stack>
            }
        >
            <ConnectionNextSteps />
        </CalendarModalPage>
    );
}
